import { render, staticRenderFns } from "./PayByMethod.vue?vue&type=template&id=27bf9270&scoped=true"
import script from "./PayByMethod.vue?vue&type=script&lang=js"
export * from "./PayByMethod.vue?vue&type=script&lang=js"
import style0 from "./PayByMethod.vue?vue&type=style&index=0&id=27bf9270&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bf9270",
  null
  
)

export default component.exports